import {t} from 'ttag';
import React, {useEffect} from 'react';
import {Box, Button, Typography} from '@mui/material';
import {useAzureAuth, useAzureLogout} from 'sata-azure-auth';
import {useNavigate} from 'react-router-dom';
import {Home} from '@mui/icons-material';
import logo from '../../../assets/sata-logo.png';

const Logout = () => {
  const {isAuthenticated, isInitialised} = useAzureAuth();
  const navigate = useNavigate();
  const logout = useAzureLogout();

  useEffect(() => {
    if (isInitialised && isAuthenticated) {
      logout();
    }
  }, [isAuthenticated, isInitialised, logout]);

  return (
    <Box sx={classes.root}>
      {isAuthenticated ? (
        <Typography align='center' variant='h2'>{t`Clearing your session, please wait...`}</Typography>
      ) : (
        <Typography align='center' variant='h2'>{t`Thank you. See you soon!`}</Typography>
      )}
      <Box mt={10} display='flex' justifyContent='center'>
        <Box
          component={'img'}
          alt='under development'
          sx={classes.image}
          src={`${process.env.PUBLIC_URL}/static/images/undraw_close_tab_uk6g.svg`}
        />
      </Box>
      <Box mt={2} display='flex' justifyContent='flex-end' width='24rem'>
        <Box component={'img'} sx={classes.logo} alt='SATA' src={logo} />
      </Box>

      {!isAuthenticated && (
        <Box mt={4} display='flex' justifyContent='center'>
          <Button color='secondary' onClick={() => navigate('/')} variant='outlined'>
            {t`Go to home page`} &nbsp; &nbsp;
            <Home />
          </Button>
        </Box>
      )}
    </Box>
  );
};

const classes = {
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    minHeight: '100%',
    padding: theme => theme.spacing(3),
    paddingTop: theme => theme.spacing(10)
  },
  caption: {
    justifyContent: 'flex-start',
    marginTop: theme => theme.spacing(1),
    display: 'flex',
    width: '20rem'
  },
  image: {
    maxWidth: '100%',
    width: '35rem',
    maxHeight: '16.75rem',
    height: 'auto'
  },
  logo: {
    width: '9.375rem'
  }
};

export default Logout;
